import React, { Component } from "react";
import Divider from "../Components/Divider";
import messenger from "../images/icons/messenger.svg";
import { connect } from "react-redux";

class Callback extends Component {
  state = {
    showModal: false,
    counter: null
  };

  handleClick = e => {
    console.log(e.target);
    e.preventDefault();
    if (
      e.target.classList.contains("close") ||
      e.target.classList.contains("modal-custom") ||
      e.target.classList.contains("messenger")
    )
      this.setState({
        showModal: !this.state.showModal
      });
  };

  componentDidUpdate() {
    if (this.state.showModal) {
      if (window.FB) window.FB.CustomerChat.showDialog();
    } else {
      if (window.FB) window.FB.CustomerChat.hideDialog();
    }
  }

  handleSubmit = e => {
    e.preventDefault();
  };

  // componentDidUpdate() {
  //   // const recaptcha = document.getElementById("recaptcha1");
  //   // if (window.grecaptcha && recaptcha) window.grecaptcha.render(recaptcha);
  // }

  render() {
    const { langBase } = this.props;

    return (
      <section>
        <div className="callme-desc">{langBase.callback_desc}</div>
        <button onClick={this.handleClick}>
          <img className="messenger" src={messenger} alt="" />
        </button>

        <Divider />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  langBase: state.langBase
});
export default connect(mapStateToProps)(Callback);
